import React, { useMemo } from 'react'
import { Stack } from '@mui/material'

import DataViewTable from '../../../../../components/shared/DataViewTable/DataViewTable'
import { nonSplConfig } from '../../../../../config/tools/productCatalogueReview/nonSplConfig'
import type { NonSplPayload } from '../../../../../config/tools/productCatalogueReview/types'

interface Props {
  data: NonSplPayload
  fpCode?: string
  title?: string
}

const NonSplTab: React.FC<Props> = ({ data, fpCode, title }) => {
  // Non-SPL rows are active products by definition (they're products with
  // recent sales or current stock); inject `active: true` so the shared
  // product-name meta renderer doesn't tag them as Inactive.
  const sellers = useMemo(
    () => data.top_sellers.map((r) => ({ ...r, active: true })),
    [data.top_sellers],
  )
  const stockHolders = useMemo(
    () => data.top_stock_holders.map((r) => ({ ...r, active: true })),
    [data.top_stock_holders],
  )
  return (
    <Stack spacing={2}>
      <DataViewTable
        config={nonSplConfig}
        data={sellers}
        variant="inspector"
        fpCode={fpCode}
        embedded
        toolbarTitle="Top non-SPL sellers"
        title={title ? `${title} - Top sellers` : undefined}
      />
      <DataViewTable
        config={nonSplConfig}
        data={stockHolders}
        variant="inspector"
        fpCode={fpCode}
        embedded
        toolbarTitle="Top non-SPL stock holders"
        title={title ? `${title} - Top stock` : undefined}
      />
    </Stack>
  )
}

export default NonSplTab
